import OBTAlert from './OBTAlert';
export default OBTAlert;
